import { TMasterStandardIndustryClassification } from "@/api/entities/master-standard-industry-classification.entity";
import { useSetHiddenStandardIndustryClassification } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenClassificationModalProps = {
  hiddenClassification?: TMasterStandardIndustryClassification;
  setHiddenClassification: Dispatch<SetStateAction<TMasterStandardIndustryClassification | undefined>>;
};

export const HiddenClassificationModal: FC<THiddenClassificationModalProps> = ({ hiddenClassification, setHiddenClassification }) => {
  const setHiddenMutation = useSetHiddenStandardIndustryClassification();

  const handleSubmit = async () => {
    if (!hiddenClassification) return;
    try {
      await setHiddenMutation.mutateAsync({ id: toNumber(hiddenClassification.id), payload: { isHidden: !hiddenClassification.isHidden } });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenClassification(undefined);
    } catch (error) {
      setHiddenClassification(undefined);
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenClassification?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={Boolean(hiddenClassification)}
      onClose={() => setHiddenClassification(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      isLoadingOkBtn={setHiddenMutation.isPending}
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenClassification?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この項目が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
